import { Container } from "pixi.js";
import { Circle } from "./Circle";
import { circleRadius, powerUpMeterPosition, circleAlpha } from "../config";
import { spinForever } from "./animations";
import Cluster from "./Cluster";

const grey = 0xaaaaaa;
const collectedGrey = 0xababab;

export class PowerUpMeter extends Container {
  enableCallback: any;
  spinTween: any;
  cluster: Cluster;
  constructor(enableCallback: () => void) {
    super();
    this.x = powerUpMeterPosition.x;
    this.y = powerUpMeterPosition.y;
    this.enableCallback = enableCallback;

    this.addClickLayer();
    this.cluster = new Cluster({ x: 0, y: 0 });
    this.addChild(this.cluster);
  }

  private quickPreCollect = () => {
    const nextCircle = this.cluster.circles.find((c) => c.color === grey);
    if (!nextCircle) return;
    nextCircle.color = collectedGrey;
  };

  public nextPosition = () => {
    let nextCircle = this.cluster.circles.find(
      (c) => c.color === collectedGrey,
    );
    if (!nextCircle)
      nextCircle = this.cluster.circles.find((c) => c.color === grey);
    return nextCircle.position;
  };

  public get full(): boolean {
    return (
      !this.cluster.circles.find((c) => c.color === collectedGrey) &&
      !this.cluster.circles.find((c) => c.color === grey)
    );
  }

  private addClickLayer = () => {
    const clickLayer = new Circle({
      x: 0,
      y: 0,
      color: grey,
      radius: circleRadius,
    });
    clickLayer.alpha = 0;
    this.addChild(clickLayer);
  };

  collect = (color: number) => {
    const nextCircle = this.cluster.circles.find((c) => c.color === grey);
    if (!nextCircle) return;
    nextCircle.color = color;
    nextCircle.redraw();
    nextCircle.appear();
    if (
      this.cluster.circles.indexOf(nextCircle) ===
      this.cluster.circles.length - 1
    ) {
      this.activateButton();
    }
  };

  private activateButton = () => {
    this.spinTween = spinForever(this);
    this.interactive = true;
    this.on("pointerup", this.enablePowerUp);
  };

  private enablePowerUp = () => {
    this.enableCallback();
    this.spinTween.kill();
    this.rotation = 0;
  };

  reset = () => {
    this.cluster.circles.forEach((c, i) => {
      setTimeout(() => {
        c.color = grey;
        c.disappear()
          .then(() => c.redraw())
          .then(() => c.appear(circleAlpha));
      }, 150 * i);
    });
  };
}

export default PowerUpMeter;
